import { Dispatch } from 'redux';
import {
    setTimeSectionLoading,
    setTimeSlots,
} from '../actions/infiniteCalendarSeries';
import { getEventDateSessions } from '../api/dateSessions';
import { getBffRequestBaseParams } from '../selectors/bff';
import {
    getParentEventInfo,
    getTimezone,
} from '../selectors/infiniteCalendarSeries/infiniteCalendarSeries';
import { CheckoutState } from '../state';
import {
    Discount,
    DiscountType,
    SalesStatus,
} from '../state/infiniteCalendarSeries';
import { removeDisabledDiscounts } from '../utils/timedEntry';

export type SessionResponse = {
    sessionId: string;
    startDatetime: string;
    endDatetime: string;
    checkoutEnabled: boolean;
    soldOut: boolean;
    urgencySignals?: {
        fewTickets: boolean;
        popular: boolean;
        goingFast: boolean;
    };
    discount?: Discount;
    minPrice?: string;
};

export const mapSessionsToTimeSlots = (sessions: SessionResponse[]) =>
    sessions.map((session) => ({
        discount: session.discount || {
            type: DiscountType.percentage,
            percentage: 0,
        },
        endDatetime: session.endDatetime,
        id: session.sessionId,
        salesStatus: session.checkoutEnabled
            ? SalesStatus.onSale
            : session.soldOut
            ? SalesStatus.soldOut
            : SalesStatus.notOnSale,
        startDatetime: session.startDatetime,
        urgencySignals: session.urgencySignals || {
            fewTickets: false,
            popular: false,
            goingFast: false,
        },
        minPrice: session.minPrice,
    }));

export const loadSessionsForDate =
    (date: string) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        dispatch(setTimeSectionLoading(true));
        dispatch(setTimeSlots([]));
        const state = getState();
        const { id: eventId } = getParentEventInfo(state);
        const { env } = getBffRequestBaseParams(state);
        const tzIdentifier = getTimezone(state);
        try {
            const response = await getEventDateSessions({
                env,
                eventId,
                date,
                tzIdentifier,
            });
            const sessions: SessionResponse[] = removeDisabledDiscounts(
                response,
                state,
            );
            dispatch(setTimeSlots(mapSessionsToTimeSlots(sessions)));
            dispatch(setTimeSectionLoading(false));
        } catch (error) {
            console.error('Error fetching date sessions:', error);
        }
    };
